import { render, staticRenderFns } from "./Zizhi.vue?vue&type=template&id=2db5dc5b&scoped=true&"
import script from "./Zizhi.vue?vue&type=script&lang=js&"
export * from "./Zizhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5dc5b",
  null
  
)

export default component.exports